export default "__VITE_ASSET__grbgMBnq__"